"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectTheme = void 0;
exports.SelectTheme = function (theme) { return (__assign(__assign({}, theme), { borderRadius: 3, colors: __assign(__assign({}, theme.colors), { neutral20: '#dee4ea', primary: '#dee4ea', primary25: '#eff2f5', neutral80: '#33414e', primary50: 'dee4ea' }) })); };
